// src/components/DefaultAdminRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { AuthContext } from '../context/AuthProvider';
import { PermissionsContext } from '../context/PermissionsProvider';
import { modules } from '../modules';

const DefaultAdminRoute = () => {
    const { auth } = useContext(AuthContext);
    const { permissions, permissionsLoaded, loading } = useContext(PermissionsContext);

    // Mientras se cargan los permisos, mostramos un spinner
    if (loading || !permissionsLoaded) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '3rem' }}>
                <CircularProgress />
            </div>
        );
    }

    // Si no hay usuario o token, forzamos login
    if (!auth?.token || !auth?.user) {
        return <Navigate to="/login" replace />;
    }

    // Revisa si el usuario tiene acceso al Dashboard: misma llave que exigen sus datos en el backend (GET /dashboard, /reports/*).
    if (permissions?.['dashboard-ver']) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    // Buscar el primer submódulo permitido en 'modules'. Mismo criterio que el
    // Sidebar: basta el permiso de la página; la llave del módulo padre no
    // siempre existe en el catálogo (p. ej. `gestion-buses`).
    for (const mod of modules) {
        for (const sub of mod.submodules || []) {
            if (permissions?.[sub.key]) {
                // Redirige al primer path que tenga acceso
                return <Navigate to={`/admin/${sub.path}`} replace />;
            }
        }
    }

    // Si no tiene acceso a ningún submódulo, redirige a algo (roles-permisos o una página de "sin acceso")
    return <Navigate to="/admin/roles-permisos" replace />;
};

export default DefaultAdminRoute;
